import bluePreview from '../../../../assets/images/video/landing-blue.png';
import greenPreview from '../../../../assets/images/video/landing-green.png';
import greyPreview from '../../../../assets/images/video/landing-grey.png';
import brownPreview from '../../../../assets/images/video/landing-brown.png';

import { ExternalLinks } from '../../../../constants';
import { PromoVideoPageConfig } from './eyes-promo-video-page.models';

const videoUrl = (id: string): string => (
  `${ExternalLinks.yandexVideoUrl}/player/video/${id}?autoplay=0&mute=0`
);

export const PROMO_VIDEO_PAGES: Record<string, PromoVideoPageConfig> = {
  blue: {
    slug: 'blue',
    mobileVideoSrc: videoUrl('vplvceema6knfegjimzr'),
    desktopVideoSrc: videoUrl('vplvxwh3fyn47vgki3pl'),
    previewSrc: bluePreview,
    background: 'radial-gradient(122.55% 86.13% at 57.81% -4.11%, #93c9ff 0.86%, #ddeeff 100%)',
  },
  green: {
    slug: 'green',
    mobileVideoSrc: videoUrl('vplvoqc7pxjv7apbfxzr'),
    desktopVideoSrc: videoUrl('vplvkugpzz2ahi7sjtkm'),
    previewSrc: greenPreview,
    background: 'radial-gradient(152.25% 108.26% at 31.98% -14.58%, #d4f3ad 0%, #f2ffe0 100%)',
  },
  grey: {
    slug: 'grey',
    mobileVideoSrc: videoUrl('vplv2fxajcmeu57u7zc2'),
    desktopVideoSrc: videoUrl('vplvmqakwo4ftn3kuwrd'),
    previewSrc: greyPreview,
    background: 'radial-gradient(120.97% 86.13% at 39.37% -4.55%, #adcdf5 0%, #dfedfe 100%)',
  },
  brown: {
    slug: 'brown',
    mobileVideoSrc: videoUrl('vplv5ukmowps2i3isiio'),
    desktopVideoSrc: videoUrl('vplvppxhhcunbvazcgaz'),
    previewSrc: brownPreview,
    background: 'radial-gradient(116.56% 83.22% at 37.19% -9.1%, #ffca95 0%, #ffefe0 100%)',
  },
};
